import React, { useEffect, useState } from "react";
import "./NCXCloseConversation.css";
import { s360ConfigService } from "../../Services/S360Config";
import Button from "@mui/material/Button";
import NCXCloseRating from "./NCXCloseRating";
import { statsigLogEvent } from "@nextiva/ncx-feature-management";
import DownloadIcon from "@mui/icons-material/Download";
import { fontFamily } from "@mui/system";
import {
  DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA,
  DATA_TEST_ID_PREFIX,
  LIVECHAT_CLICK_EVENTS,
  LIVECHAT_LOG_EVENTS,
  LIVECHAT_LOG_KEYS,
  LIVECHAT_LOG_ACTIONS,
} from "../../../utils/Constants/statsig.constants";
import flowMemorySingleton from "../../Services/FlowMemorySingleton";
import { analyzeMessages } from "../utils/ConversationUtils";
export default function NCXCloseConversation(props) {
  const [isVisible, setIsVisible] = useState(false);
  const agentNameParse = () => {
    try {
      return s360ConfigService.getConfig()?.s360UserConfig?.agentName || "User";
    } catch (e) {
      return "User";
    }
  };

  const {
    onCancelClose,
    onConfirmClose,
    downloadChatTranscript,
    restartNCXConversation,
    fromHistory = false,
    onGoToLanding,
    sessionId,
    messages,
  } = props;
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const configPrimaryColor =
    s360ConfigService?.config?.configDetails?.primaryColor || "#015fe";

  const handleClickDownloadTranscript = () => {
    if (s360ConfigService.config.sandBox) {
      return;
    }
    downloadChatTranscript();
  };

  const handleClickEndChat = () => {
    if (s360ConfigService.config.sandBox) {
      return;
    }

    const { isBotEnabled, isAiBot, hasImageAttached } =
      analyzeMessages(messages);

    const isAgentStarted = flowMemorySingleton.getAgentMessageStarted();

    const basePayload = {
      [LIVECHAT_LOG_KEYS.action]: isAgentStarted
        ? LIVECHAT_LOG_ACTIONS.CLOSE_CHAT_WITH_AGENT
        : LIVECHAT_LOG_ACTIONS.CLOSE_CHAT_WITHOUT_AGENT,
      [LIVECHAT_LOG_KEYS.widgetConfigId]:
        s360ConfigService?.config?.widgetconfigId,
      [LIVECHAT_LOG_KEYS.campaignId]: s360ConfigService?.config?.campaignId,
      [LIVECHAT_LOG_KEYS.timeStamp]: Date.now(),
      [LIVECHAT_LOG_KEYS.sessionId]: sessionId,
      [LIVECHAT_LOG_KEYS.isBotEnabled]: isBotEnabled,
      [LIVECHAT_LOG_KEYS.isAIBot]: isAiBot,
      [LIVECHAT_LOG_KEYS.hasImageAttached]: hasImageAttached,
      [LIVECHAT_LOG_KEYS.FAQArticleClicked]: localStorage.getItem("FAQ_Article_Clicked") === "true",
      isChatSessionTimedOut: false,
    };

    let eventName;

    if (s360ConfigService?.config?.connectToNextiva) {
      eventName = isAgentStarted
        ? LIVECHAT_LOG_EVENTS.CONNECT_NEXTIVA_AGENT_CHAT
        : LIVECHAT_LOG_EVENTS.CONNECT_NEXTIVA_BOT_CHAT;
    } else {
      eventName = LIVECHAT_LOG_EVENTS.CLOSE_CHAT;
    }

    statsigLogEvent(eventName, basePayload);

    onConfirmClose();
  };

  const handleClickContinueChat = () => {
    onCancelClose();
  };

  const handleClickStartNewChat = () => {
    if (s360ConfigService.config.sandBox) {
      return;
    }
    restartNCXConversation();
  };

  return (
    <div className={`ncx-close-conversation ${isVisible ? "fade-in" : ""}`}>
      <div className="ncx-close-conversation-top">
        <h5>
          {props.sessionClosedbyAgent
            ? `${s360ConfigService?.config?.configDetails?.sessionCloseMessage}`
            : `Thank you for chatting with us.`}
        </h5>
        {s360ConfigService?.config?.configDetails?.sendChatTranscript && (
          <div className="ncx-close-conversation-transcript">
            <p>{`I made a transcript of our chat session today if you want a copy of it.`}</p>
            <Button
              style={{
                color: "#005FEC",
                fontFamily: "Lato",
                fontSize: "12px",
                fontWeight: 800,
                lineHeight: "16px",
                letterSpacing: "0.25px",
                textAlign: "center",
                padding: "8px 16px",
                borderRadius: "5px",
              }}
              startIcon={<DownloadIcon />}
              onClick={handleClickDownloadTranscript}
              data-testid={`${
                s360ConfigService?.config?.connectToNextiva
                  ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                  : DATA_TEST_ID_PREFIX
              }-${
                LIVECHAT_CLICK_EVENTS.CLOSE_CONVERSATION_DIALOG_DOWNLOAD_TRANSCRIPT
              }`}
            >
              Download transcript
            </Button>
          </div>
        )}
        {!fromHistory ? (
          <div className="ncx-close-conversation-close-menu">
            <div className="ncx-close-conversation-top-confirm">
              {props.sessionClosedbyAgent ? null : (
                <Button
                  variant="filled"
                  onClick={handleClickEndChat}
                  style={{
                    fontFamily: "Lato",
                    fontWeight: 800,
                    fontSize: "button",
                    lineHeight: "16px",
                    letterSpacing: " 0.25px",
                    textAlign: "center",
                    background: configPrimaryColor,
                    color: "#FFFFFF",
                    borderRadius: "2px",
                    minWidth: "120px",
                    minHeight: "30px",
                  }}
                >
                  End chat
                </Button>
              )}
              <Button
                variant="filled"
                style={{
                  fontFamily: "Lato",
                  fontWeight: 800,
                  fontSize: "button",
                  lineHeight: "16px",
                  letterSpacing: " 0.25px",
                  textAlign: "center",
                  background: "#EAEBEF",
                  color: "#000000",
                  borderRadius: "2px",
                  minWidth: "120px",
                  minHeight: "30px",
                }}
                onClick={handleClickStartNewChat}
              >
                Start new chat
              </Button>
            </div>
          </div>
        ) : (
          <div className="ncx-close-conversation-close-menu">
            <div className="ncx-close-conversation-top-confirm">
              <Button
                variant="filled"
                style={{
                  fontFamily: "Lato",
                  fontWeight: 800,
                  fontSize: "button",
                  lineHeight: "16px",
                  letterSpacing: " 0.25px",
                  textAlign: "center",
                  background: "#EAEBEF",
                  color: "#000000",
                  borderRadius: "2px",
                  minWidth: "120px",
                }}
                onClick={onGoToLanding}
              >
                Go Back
              </Button>
            </div>
          </div>
        )}
        {props.sessionClosedbyAgent ? null : (
          <p
            style={{
              color: "#0B1029",

              fontFamily: "Lato",
              fontSize: "14px",
              fontWeight: 800,
              lineHeight: "16px",
              letterSpacing: "0.25px",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={handleClickContinueChat}
            data-testid={`${
              s360ConfigService?.config?.connectToNextiva
                ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                : DATA_TEST_ID_PREFIX
            }-${LIVECHAT_CLICK_EVENTS.CLOSE_CONVERSATION_DIALOG_CONTINUE_CHAT}`}
          >
            Continue chat
          </p>
        )}
      </div>
      {/* <div className="ncx-close-conversation-bottom">
        <NCXCloseRating />
      </div> */}
    </div>
  );
}
